// @flow
import React from 'react';
import Select from 'sail/Select';
import {InputBase, InputInlay} from 'sail/Input';
import {CaptionMono} from 'sail/Text';
import {dimensions} from '../StyleHelpers';

type BooleanInputProps = {|
  field_id: string,
  param_key: string,
  required: boolean,
  inputType: string,
  params: Object,
  setParams: (Object) => void,
|};

const handleParamChange = (param_key, value, params, setParams) => {
  if (value === 'true') {
    setParams({...params, [param_key]: true});
  } else if (value === 'false') {
    setParams({...params, [param_key]: false});
  } else {
    const {[param_key]: removed, ...newParams} = params;
    setParams(newParams);
  }
};

export const BooleanInput = ({
  field_id,
  param_key,
  required,
  inputType,
  params,
  setParams,
}: BooleanInputProps) => {
  let valueHelper = '';
  if (typeof params[param_key] === 'boolean') {
    valueHelper = params[param_key] ? 'true' : 'false';
  }

  return (
    <InputBase width={dimensions.width} radius="none">
      <Select
        id={field_id}
        value={valueHelper}
        onChange={(value) =>
          handleParamChange(param_key, value, params, setParams)
        }
        width="maximized"
        size="large"
        defaultValue=""
        options={[
          {
            value: '',
            label: '',
          },
          {
            value: 'true',
            label: 'true',
          },

          {
            value: 'false',
            label: 'false',
          },
        ]}
        sortOptions={false}
      />
      <InputInlay buffer="horizontal" size="large">
        <CaptionMono color="gray">boolean</CaptionMono>
      </InputInlay>
    </InputBase>
  );
};
